document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');

  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
      document.body.classList.toggle('menu-open', !open);
    });
  }

  const catalogDropdowns = document.querySelectorAll('[data-catalog-dropdown]');

  document.addEventListener('click', (event) => {
    catalogDropdowns.forEach((dropdown) => {
      if (dropdown.open && !dropdown.contains(event.target)) dropdown.open = false;
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    catalogDropdowns.forEach((dropdown) => { dropdown.open = false; });
  });

  document.querySelectorAll('[data-quantity]').forEach((control) => {
    const input = control.querySelector('input');
    control.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const delta = button.dataset.action === 'increase' ? 1 : -1;
        const next = Math.max(Number(input.min || 1), Number(input.value || 1) + delta);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  const storeFaqSelectors = [
    '[data-storefaq-launcher]',
    '[data-testid*="storefaq" i][role="button"]',
    '[data-testid*="launcher" i]',
    '[id*="storefaq" i] button',
    '[class*="storefaq" i] button',
    '[id*="instant-answer" i] button',
    '[class*="instant-answer" i] button',
    'button[aria-label*="chat" i]',
    '[role="button"][aria-label*="chat" i]',
    'button[title*="chat" i]',
    '[role="button"][title*="chat" i]'
  ];

  const findStoreFaqLauncher = () => {
    const roots = [document];

    for (let index = 0; index < roots.length; index += 1) {
      const root = roots[index];

      root.querySelectorAll('*').forEach((element) => {
        if (element.shadowRoot && !roots.includes(element.shadowRoot)) roots.push(element.shadowRoot);
      });

      for (const selector of storeFaqSelectors) {
        const candidates = root.querySelectorAll(selector);

        for (const candidate of candidates) {
          if (candidate.closest?.('[data-open-storefaq]')) continue;
          const rect = candidate.getBoundingClientRect();
          const style = window.getComputedStyle(candidate);
          if (rect.width > 0 && rect.height > 0 && style.visibility !== 'hidden' && style.display !== 'none') return candidate;
        }
      }
    }

    return null;
  };

  document.addEventListener('click', (event) => {
      const trigger = event.target.closest?.('[data-open-storefaq]');
      if (!trigger || trigger.disabled) return;
      const status = trigger.closest('[data-contact-options]')?.querySelector('[data-storefaq-status]');
      let attempts = 0;
      trigger.disabled = true;
      trigger.setAttribute('aria-busy', 'true');
      if (status) status.textContent = 'Opening chatbot…';

      window.dispatchEvent(new CustomEvent('storefaq:open'));

      const openLauncher = () => {
        const launcher = findStoreFaqLauncher();

        if (launcher) {
          if (launcher.getAttribute('aria-expanded') !== 'true') launcher.click();
          trigger.disabled = false;
          trigger.removeAttribute('aria-busy');
          if (status) status.textContent = '';
          return;
        }

        attempts += 1;
        if (attempts < 16) {
          window.setTimeout(openLauncher, 250);
          return;
        }

        trigger.disabled = false;
        trigger.removeAttribute('aria-busy');
        if (status) status.textContent = 'Chatbot is currently unavailable. Please use Instagram or WhatsApp.';
      };

      openLauncher();
  });
});
